import React from 'react';
import ImageBlock from './ImageBlock';
import WysiwygBlock from './WysiwygBlock';
import GalleryBlock from './GalleryBlock';
import FaqBlock from './FaqBlock';
import ButtonBlock from './ButtonBlock';
import LegacyEditor from '../content-editor/Editor.js';
import {BlockTypes, WidgetTypes} from '/src/model/transformers/block';
import update from 'immutability-helper';
import CodeMirror from '@uiw/react-codemirror';
import {html} from '@codemirror/lang-html';

const BlockAddButtons = (props) => {
  return (<div style={{
    border: '1px dashed lightgray',
    padding: '10px',
    borderRadius: '7px',
    marginBottom: '20px'
  }}>
    <span className="glyphicon glyphicon-plus" aria-hidden="true"></span>
    &nbsp;
    <input onClick={() => props.handler(BlockTypes.WIDGET, props.index, WidgetTypes.WYSIWYG)} className="btn btn-default" type="button" value="Tekst"/>
    &nbsp;
    <input className="btn btn-default" onClick={() => props.handler(BlockTypes.IMAGE, props.index)} type="button" value={props.allowVideo ? 'Bilde / Video' : 'Bilde'}/>
    &nbsp;
    <input className="btn btn-default" onClick={() => props.handler(BlockTypes.WIDGET, props.index, WidgetTypes.GALLERY)} type="button" value="Bildegalleri"/>
    &nbsp;
    {props.enableLease && <>
      <input onClick={() => props.handler(BlockTypes.WIDGET, props.index, WidgetTypes.LEASE)} className="btn btn-default" type="button" value="Lease"/>
      &nbsp;
    </>}
    {props.enableTwoColumns && <>
      <div className="dropdown" style={{display: 'inline-block'}}>
        <button className="btn btn-default dropdown-toggle" type="button" id="dropdownMenu-column" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
          2-kolonne &nbsp;
          <span className="caret"></span>
        </button>
        <ul className="dropdown-menu" aria-labelledby="dropdownMenu-column">
          <li><a className="text-center" onClick={(e) => e.preventDefault() || props.handler(BlockTypes.WIDGET, props.index, 'twoColumns', 1)} href="#"><span className="glyphicon glyphicon-align-left" aria-hidden="true"></span>&nbsp;<span className="glyphicon glyphicon-picture" aria-hidden="true"></span></a></li>
          <li><a className="text-center" onClick={(e) => e.preventDefault() || props.handler(BlockTypes.WIDGET, props.index, 'twoColumns', 2)} href="#"><span className="glyphicon glyphicon-align-left" aria-hidden="true"></span>&nbsp;<span className="glyphicon glyphicon-align-left" aria-hidden="true"></span></a></li>
          <li><a className="text-center" onClick={(e) => e.preventDefault() || props.handler(BlockTypes.WIDGET, props.index, 'twoColumns', 3)} href="#"><span className="glyphicon glyphicon-picture" aria-hidden="true"></span>&nbsp;<span className="glyphicon glyphicon-align-left" aria-hidden="true"></span></a></li>
          <li><a className="text-center" onClick={(e) => e.preventDefault() || props.handler(BlockTypes.WIDGET, props.index, 'twoColumns', 4)} href="#"><span className="glyphicon glyphicon-picture" aria-hidden="true"></span>&nbsp;<span className="glyphicon glyphicon-picture" aria-hidden="true"></span></a></li>
        </ul>
      </div>
      &nbsp;
    </>}
    <input className="btn btn-default" onClick={() => props.handler(BlockTypes.WIDGET, props.index, WidgetTypes.BUTTON)} type="button" value="Knapp"/>
    &nbsp;
    <input onClick={() => props.handler(BlockTypes.WIDGET, props.index, WidgetTypes.HTML)} className="btn btn-default" type="button" value="HTML"/>
    {props.enableFaq && <>
      <input onClick={() => props.handler(BlockTypes.WIDGET, props.index, WidgetTypes.FAQ)} className="btn btn-default" type="button" value="FAQ"/>
      &nbsp;
    </>}
    {props.enableModelContent && <>
      &nbsp;
      <div className="dropdown" style={{display: 'inline-block'}}>
        <button className="btn btn-default dropdown-toggle" type="button" id="dropdownMenu-model" data-toggle="dropdown" aria-haspopup="true" aria-expanded="true">
          Modellinformasjon &nbsp;
          <span className="caret"></span>
        </button>
        <ul className="dropdown-menu" aria-labelledby="dropdownMenu-model">
          <li><a className="text-center" onClick={(e) => e.preventDefault() || props.handler(BlockTypes.WIDGET, props.index, WidgetTypes.MODEL_CAMPAIGNS)} href="#">Kampanjeoversikt</a></li>
          <li><a className="text-center" onClick={(e) => e.preventDefault() || props.handler(BlockTypes.WIDGET, props.index, WidgetTypes.MODEL_ARTICLES)} href="#">Tips og råd</a></li>
          <li><a className="text-center" onClick={(e) => e.preventDefault() || props.handler(BlockTypes.WIDGET, props.index, WidgetTypes.MODEL_GALLERIES)} href="#">Bildegalleri</a></li>
          <li><a className="text-center" onClick={(e) => e.preventDefault() || props.handler(BlockTypes.WIDGET, props.index, WidgetTypes.MODEL_BROCHURES)} href="#">Brosjyrer</a></li>
          <li><a className="text-center" onClick={(e) => e.preventDefault() || props.handler(BlockTypes.WIDGET, props.index, WidgetTypes.MODEL_STOCKCARS)} href="#">Biler på lager</a></li>
          <li><a className="text-center" onClick={(e) => e.preventDefault() || props.handler(BlockTypes.WIDGET, props.index, WidgetTypes.MODEL_EQUIPMENTLEVELS)} href="#">Utstyrsnivå</a></li>
        </ul>
      </div>
      &nbsp;
    </>}
    {props.children}
  </div>);
};

class Editor extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      blocks: props.blocks || []
    };

    this.handleBlocksUpdate = this.handleBlocksUpdate.bind(this);
    this.handleBlockChange = this.handleBlockChange.bind(this);
    this.handleTextBlockChange = this.handleTextBlockChange.bind(this);
    this.handleBlockAdd = this.handleBlockAdd.bind(this);
    this.handleBlockMove = this.handleBlockMove.bind(this);
    this.handleBlockDelete = this.handleBlockDelete.bind(this);
  }

  handleBlocksUpdate(blocks) {
    this.setState({
      blocks: blocks
    });

    this.props.onChange(blocks);
  }

  handleBlockChange(id, value) {
    const blockIndex = this.state.blocks.findIndex((b) => (b.id || b.tmpId) === id);
    const newData = update(this.state.blocks, {
      [blockIndex]: {
        $merge: value,
        dirty: {
          $set: true
        }
      }
    });

    this.handleBlocksUpdate(newData);
  }

  handleTextBlockChange(e) {
    this.handleBlockChange(e.target.name, {
      text: e.target.value
    });
  }

  handleBlockAdd(type, index, widgetType, data) {
    // NOTE: we mutate the state directly, we will rerender anyway because we call the props.onChange.
    // This is a pattert going on a lot in Admin..

    if (widgetType === 'twoColumns') {
      // Add two columns
      let typeLeft;
      let typeRight;
      switch (data) {
        case 1:
          typeLeft = [BlockTypes.WIDGET, WidgetTypes.WYSIWYG];
          typeRight = [BlockTypes.IMAGE];
          break;
        case 2:
          typeLeft = [BlockTypes.WIDGET, WidgetTypes.WYSIWYG];
          typeRight = [BlockTypes.WIDGET, WidgetTypes.WYSIWYG];
          break;
        case 3:
          typeLeft = [BlockTypes.IMAGE];
          typeRight = [BlockTypes.WIDGET, WidgetTypes.WYSIWYG];
          break;
        case 4:
          typeLeft = [BlockTypes.IMAGE];
          typeRight = [BlockTypes.IMAGE];
          break;
      }

      this.state.blocks.splice(index, 0, {
        tmpId: `${Date.now()}-0`,
        type: typeLeft[0],
        widget: typeLeft[1],
        data: {
          layout: 'twoColumns',
          position: 'left'
        }
      }, {
        tmpId: `${Date.now()}-1`,
        type: typeRight[0],
        widget: typeRight[1],
        data: {
          layout: 'twoColumns',
          position: 'right'
        }
      });
    } else if (widgetType === WidgetTypes.BUTTON) {
      this.state.blocks.splice(index, 0, {
        tmpId: `${Date.now()}`,
        type: type,
        widget: widgetType,
        data: {
          buttons: 1
        }
      });
    } else {
      this.state.blocks.splice(index, 0, {
        tmpId: `${Date.now()}`,
        type: type,
        widget: widgetType
      });
    }

    this.handleBlocksUpdate(this.state.blocks);
  }

  handleBlockMove(fromIndex, toIndex, howMany) {
    if (fromIndex > toIndex) {
      if (this.state.blocks[toIndex].data && this.state.blocks[toIndex].data.layout) {
        if (this.state.blocks[toIndex].data.layout === 'twoColumns' && this.state.blocks[toIndex].data.position === 'right') {
          // Handle the move by making sure we are not splitting up any two columns layout
          // Move it before the two column setup.
          toIndex--;
        }
      }
      this.state.blocks.splice(toIndex, 0, ...this.state.blocks.splice(fromIndex, howMany));
    } else {
      if (this.state.blocks[toIndex].data && this.state.blocks[toIndex].data.layout) {
        if (this.state.blocks[toIndex].data.layout === 'twoColumns' && this.state.blocks[toIndex].data.position === 'left') {
          // Handle the move by making sure we are not splitting up any two columns layout
          // Move it after the two column setup.
          toIndex++;
        }
      }
      this.state.blocks.splice(toIndex - howMany + 1, 0, ...this.state.blocks.splice(fromIndex, howMany));
    }

    this.handleBlocksUpdate(this.state.blocks);
  }

  handleBlockDelete(index, howMany) {
    this.state.blocks.splice(index, howMany);

    this.handleBlocksUpdate(this.state.blocks);
  }

  // TODO: handle props.disabled
  // TODO: handle props.disabled
  // TODO: handle props.disabled
  // TODO: handle props.disabled
  // TODO: handle props.disabled
  // TODO: handle props.disabled
  // TODO: handle props.disabled

  render() {
    const panelWrappedBlocks = [];
    for (let i = 0; i < this.state.blocks.length; /*i++ this is done in the nested loop*/) {
      const clusterStartBlock = this.state.blocks[i];

      let blockClustersize = 1;
      let className = 'col-xs-12';
      if (clusterStartBlock.data && clusterStartBlock.data.layout) {
        if (clusterStartBlock.data.layout === 'twoColumns') {
          className = 'col-xs-12 col-md-6';
          blockClustersize = 2;
        }
      }

      const clusterBlocks = [];
      // Iterate through the blocks that should be within this editor/cluster
      // which should only be 1 except for the two-column..
      const endOfIforThisCluster = i + blockClustersize;
      for (; i < endOfIforThisCluster; i++) {
        const block = this.state.blocks[i];
        const id = block.id || block.tmpId;
        let blockEditor;
        let title;
        let label;

        switch (block.type) {
          case BlockTypes.TEXT:
            title = 'Tekst';
            blockEditor = <div>
              <div className="alert alert-warning mf-margin-bottom-5"><strong>Utdatert blokk!</strong> Kopier teksten til en ny blokktype og slett denne for å gjøre endringer</div>
              <LegacyEditor blocks={[block]} disabled />
            </div>;
            break;
          case BlockTypes.WIDGET:
            switch (block.widget) {
              case WidgetTypes.HTML:
                title = 'HTML';
                blockEditor = <CodeMirror
                  value={block.content}
                  height="350px"
                  extensions={html()}
                  onChange={(value) => this.handleBlockChange(id, {
                    content: value
                  })}
                />;
                break;
              case WidgetTypes.WYSIWYG:
                title = 'Tekst';
                blockEditor = <WysiwygBlock
                  onChange={(value) => this.handleBlockChange(id, {
                    content: value
                  })}
                  name={id}
                  value={block.content}
                />;
                if (blockClustersize === 2) {
                  blockEditor = <div>
                    {blockEditor}
                    <details className="mf-margin-top-10">
                      <summary>
                        <span className="mf-margin-right-20">
                          <span className="caret"></span>
                          &nbsp; Legg til Knapp
                        </span>
                        {block.data?.buttonUrl && <a target="_blank" rel="noreferrer" href={block.data?.buttonUrl}>{block.data?.buttonText}</a>}
                      </summary>
                      <div className="mf-margin-top-10">
                        <div className="col-xs-12">
                          <label>Type</label>
                          <div className="form-group">
                            <select
                              className="form-control mf-margin-right-20"
                              defaultValue={block.data?.buttonType || 'primary'}
                              onChange={(e) => this.handleBlockChange(id, {
                                data: {
                                  ...block.data,
                                  buttonType: e.target.value,
                                }
                              })}
                            >
                              <option value="primary">Primær</option>
                              <option value="secondary">Sekundær</option>
                              <option value="tertiary">Tertiær</option>
                            </select>
                          </div>
                        </div>
                        <div className="col-xs-12">
                          <label>Tekst</label>
                          <div className="form-group">
                            <input
                              className="form-control"
                              value={block.data?.buttonText || ''}
                              type="text"
                              name="tekst"
                              onChange={(e) => this.handleBlockChange(id, {
                                data: {
                                  ...block.data,
                                  buttonText: e.target.value,
                                }
                              })}
                            />
                          </div>
                        </div>
                        <div className="col-xs-12">
                          <label>URL</label>
                          <div className="form-group">
                            <input
                              className="form-control"
                              value={block.data?.buttonUrl || ''}
                              type="url"
                              name="url"
                              onChange={(e) => this.handleBlockChange(id, {
                                data: {
                                  ...block.data,
                                  buttonUrl: e.target.value,
                                }
                              })}
                            />
                          </div>
                        </div>
                        <div className="col-xs-12">
                          <div className="checkbox mf-margin-right-20"><label>
                            <input
                              type="checkbox"
                              value=""
                              onChange={(e) => this.handleBlockChange(id, {
                                data: {
                                  ...block.data,
                                  buttonBlank: e.target.checked,
                                }
                              })}
                              name="fullwidth"
                              defaultChecked={block.data?.buttonBlank}
                            />
                              Åpnes i ny fane
                            </label></div>
                        </div>
                      </div>
                    </details>
                  </div>;
                }
                break;
              case WidgetTypes.GALLERY:
                title = 'Bildegalleri';
                blockEditor = <GalleryBlock
                  onChange={(value) => this.handleBlockChange(id, value)}
                  value={block}
                  predefinedTags={this.props.predefinedTags}
                />;
                break;
              case WidgetTypes.FAQ:
                title = 'FAQ';
                blockEditor = <FaqBlock
                  onChange={(value) => this.handleBlockChange(id, value)}
                  value={block}
                />;
                break;
              case WidgetTypes.LEASE:
                title = 'Lease';
                blockEditor = <div className="mf-margin-top-20 mf-margin-bottom-20">
                  <i>Henter leaseinformasjon fra tilkoblet leasing</i>
                </div>;
                break;
              case WidgetTypes.MODEL_CAMPAIGNS:
                title = 'Kampanjeoversikt';
                label = 'Modellinformasjon';
                blockEditor = <div className="mf-margin-top-20 mf-margin-bottom-20">
                  <i>Viser kampanjeoversikten for denne modellen</i>
                </div>;
                break;
              case WidgetTypes.MODEL_ARTICLES:
                title = 'Tips og råd';
                label = 'Modellinformasjon';
                blockEditor = <div className="mf-margin-top-20 mf-margin-bottom-20">
                  <i>Viser liste over artikler koblet til denne modellen</i>
                </div>;
                break;
              case WidgetTypes.MODEL_GALLERIES:
                title = 'Bildegalleri';
                label = 'Modellinformasjon';
                blockEditor = <div className="mf-margin-top-20 mf-margin-bottom-20">
                  <i>Viser bildegallerier for denne modellen</i>
                </div>;
                break;
              case WidgetTypes.MODEL_BROCHURES:
                title = 'Brosjyrer';
                label = 'Modellinformasjon';
                blockEditor = <div className="mf-margin-top-20 mf-margin-bottom-20">
                  <i>Viser brosjyreoversikt for denne modellen</i>
                </div>;
                break;
              case WidgetTypes.MODEL_STOCKCARS:
                title = 'Biler på lager';
                label = 'Modellinformasjon';
                blockEditor = <div className="mf-margin-top-20 mf-margin-bottom-20">
                  <i>Viser tilgjengelige biler på lager</i>
                </div>;
                break;
              case WidgetTypes.MODEL_EQUIPMENTLEVELS:
                title = 'Utstyrsnivå';
                label = 'Modellinformasjon';
                blockEditor = <div className="mf-margin-top-20 mf-margin-bottom-20">
                  <i>Viser liste over utstyrsnivåene for denne modellen</i>
                </div>;
                break;
              case WidgetTypes.MD:
                title = 'Markdown';
              // eslint-disable-next-line no-fallthrough
              case WidgetTypes.TEXT:
                title = 'Enkel tekst';
                blockEditor = <textarea
                  onChange={(e) => this.handleBlockChange(id, {
                    content: e.target.value
                  })}
                  name={id}
                  className="form-control"
                  rows="10"
                  defaultValue={block.content}></textarea>;
                break;
              case WidgetTypes.BUTTON:
                title = 'Knapp';
                blockEditor = <ButtonBlock
                  onChange={(value) => this.handleBlockChange(id, value)}
                  value={block}
                />;
                break;
              default:
                blockEditor = <div className="alert alert-danger mf-margin-bottom-5"><strong>Ukjent blokk!</strong> Denne widget-typen er ikke støttet</div>;
            }
            break;
          case BlockTypes.IMAGE:
            title = this.props.allowVideo ? 'Bilde / Video' : 'Bilde';
            blockEditor = <ImageBlock allowVideo={this.props.allowVideo} onChange={(value) => this.handleBlockChange(id, value)} name={id} block={block} allowFullwidth={blockClustersize === 1} predefinedTags={this.props.predefinedTags} />;
            break;
          default:
            blockEditor = <div className="alert alert-danger mf-margin-bottom-5"><strong>Ukjent blokk!</strong> Denne blokk-typen er ikke støttet</div>;
        }

        if (blockClustersize === 2) {
          title = '2-kolonne';
        }

        clusterBlocks.push({
          id: id,
          title: title,
          label: label,
          editor: blockEditor,
          data: block.data
        });
      }

      panelWrappedBlocks.push({
        id: clusterBlocks[0].id,
        index: i,
        size: blockClustersize,
        panel: <div className="panel panel-default">
          <div className="panel-heading">
            <div className="panel-title clearfix">
              <h4 className="pull-left" style={{margin: 0}}>{clusterBlocks[0].title}</h4>
              {this.props.enableBlockAdjustments && <div className="checkbox pull-left" style={{margin: 0}}>
                <label style={{fontWweight: 'normal', fontSize: '14px', marginLeft: '10px'}}>
                  <input type="checkbox" name="noSpace" defaultChecked={clusterBlocks[0].data?.noSpace} onClick={() => this.handleBlockChange(clusterBlocks[0].id, {
                    data: {
                      ...clusterBlocks[0].data,
                      noSpace: !clusterBlocks[0].data?.noSpace
                    }
                  })} style={{marginRight: '5px'}} /> Ingen margin
                </label>
              </div>}
              {this.props.enableBlockAdjustments && blockClustersize === 2 && <div className="checkbox pull-left" style={{margin: 0}}>
                <label style={{fontWweight: 'normal', fontSize: '14px', marginLeft: '10px'}}>
                  <input type="checkbox" name="invertColor" defaultChecked={clusterBlocks[0].data?.invertColor} onClick={() => this.handleBlockChange(clusterBlocks[0].id, {
                    data: {
                      ...clusterBlocks[0].data,
                      invertColor: !clusterBlocks[0].data?.invertColor
                    }
                  })} style={{marginRight: '5px'}} /> Lys bakgrunn
                </label>
              </div>}
              {clusterBlocks[0].label && <span className="label label-info mf-margin-left-20">{clusterBlocks[0].label}</span>}
              <div className="pull-right">
                {(i - blockClustersize) > 0 && <input className="btn btn-default" onClick={() => this.handleBlockMove((i - blockClustersize), (i - blockClustersize - 1), blockClustersize)} type="button" value="Flytt opp"/>}
                &nbsp;
                {i < this.state.blocks.length && <input className="btn btn-default" onClick={() => this.handleBlockMove((i - blockClustersize), i, blockClustersize)} type="button" value="Flytt ned"/>}
                &nbsp;
                <input onClick={() => this.handleBlockDelete(i - blockClustersize, blockClustersize)} className="btn btn-danger" type="button" value="Slett"/>
              </div>
            </div>
          </div>
          <div className="panel-body">
            {clusterBlocks.map((cb) => (
              <div key={cb.id} className={className}>
                {cb.editor}
              </div>
            ))}
          </div>
        </div>
      }
      );
    }

    return (
      <div className="row">
        <div className="col-xs-12">
          <BlockAddButtons
            handler={this.handleBlockAdd}
            enableLease={this.props.enableLeaseWidget}
            enableModelContent={this.props.enableModelContent}
            enableTwoColumns={this.props.enableTwoColumns}
            enableFaq={this.props.enableFaq}
            allowVideo={this.props.allowVideo}
            index={0}
          />
        </div>
        {panelWrappedBlocks.map((block, i) => (
          <React.Fragment key={`panel-${block.id}-${i}`}>
            <div className="col-xs-12">
              {block.panel}
            </div>
            <div className="col-xs-12">
              <BlockAddButtons
                handler={this.handleBlockAdd}
                enableLease={this.props.enableLeaseWidget}
                enableModelContent={this.props.enableModelContent}
                enableTwoColumns={this.props.enableTwoColumns}
                enableFaq={this.props.enableFaq}
                allowVideo={this.props.allowVideo}
                index={block.index}
              />
            </div>
          </React.Fragment>
        ))}
      </div>
    );
  }
}

export default Editor;
